export default __webpack_public_path__ + "static/media/fedele.c43f7148.jpg";